import { render, staticRenderFns } from "./radiology.vue?vue&type=template&id=790b38f3&"
import script from "./radiology.vue?vue&type=script&lang=js&"
export * from "./radiology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports